{
    "LogFileDownload_DownloadTitle": "Download **{}**",
    "LogFileDownload_HowManyFiles": "Quantos arquivos anteriores você gostaria de baixar?",
    "LogFileDownload_AllFiles": "Todos os arquivos",
    "LogFileDownload_NFile": "Arquivo(s) {} passado(s)",
    "LogFileDownload_CurrentFile": "Arquivo atual",
    "NAME": "LanguageLogFileDownload"
}